// extracted by mini-css-extract-plugin
export default {"loginFormContainer":"XipsUJasB1MZb5LE4OwC","loginForm":"jbSRY4PPWQqofAvchSIV","loginTextBox":"Sk_PUVkJn7_YGPqULfoW"};